import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// This page is no longer used — processing now happens inside /user-onboarding.
// Redirect any stale links or bookmarks to the new flow.
const ScreeningProcessingPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/user-onboarding", { replace: true });
  }, [navigate]);

  return null;
};

export default ScreeningProcessingPage;
